import { Component } from '@angular/core';
import * as fromConstants from '../../constants';
@Component({
  selector: 'hdw-footer',
  templateUrl: './hdw-footer.component.html',
  styleUrls: ['./hdw-footer.component.scss']
})
export class HdwFooterComponent {
  public footerLinks = fromConstants.FooterLinks;
}
